import $ from 'jquery';
import 'bootstrap-slider';

$.addInit(function(context) {
	var base = '.i-range';

	$(base, context).each(function(){
		var component = $(this);

		var slide = component.find(base + '-slider');
		var rangeStore = component.data('rangeStore');

		var minValue = Math.floor(slide.data('sliderMin'));
		var maxValue = Math.ceil(slide.data('sliderMax'));

		var maxInput = component.find(base + '-inputSingle');

		function getInputValue() {
			return Math.ceil(maxInput.val());
		}

		function setInputValue(value) {
			getCalculatedPrice(value);

			if (value <= 0) {
				maxInput.val(value < minValue ? '' : value);
			} else {
				maxInput.val(value);
			}
		}

		function getCalculatedPrice(value) {
			var rangeStoreItem = rangeStore.filter(function(item) {
				var currentValue = item.isCurrentValue ? value : item.value[1];

				return value > 0 && currentValue >= value;
			});

			component.trigger('setPrice',
				[
					rangeStoreItem[0] ?
					(
						rangeStoreItem[0].countValue ? 
						rangeStoreItem[0].price * value : 
						rangeStoreItem[0].price
					) : '',
					value
				]
			);
		}

		getCalculatedPrice(getInputValue());

		slide.slider({
			value: getInputValue(),
			min: minValue,
			max: maxValue,
			tooltip: 'hide',
		});

		slide.on('change', function(e) {
			setInputValue(e.value.newValue);
		});

		maxInput.on('change', function() {
			var value = getInputValue();

			setInputValue(value);
			slide.slider('setValue', value);
		});
	});
});
